<template>
  <!-- Modal Overlay -->
  <div v-if="show" class="registration-modal-overlay" @click.self="closeModal">
    <!-- Modal Content -->
    <div class="registration-modal-content" @click.stop>
      <!-- Close Button (X) -->
      <button class="modal-close-btn" @click="closeModal">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18 6L6 18"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
          <path
            d="M6 6L18 18"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </button>
      <section
        class="login_Form"
        style="margin-top: 67px; scrollbar-width: none"
      >
        <div id="slider">
          <div v-show="currentIndex === 0" class="slides">
            <img
              src="../../assets/login/Landing_page-middle_content_static_images/doctor-vector.svg"
              width="100%"
              height="100%"
            />
            <h3 class="languageChange" id="langChange63">Doctors</h3>
            <br />
            <p class="slider_subheading languageChange" id="langChange64">
              All doctors treat, but a good doctor let nature heal
            </p>
            <p class="Slider_content languageChange" id="langChange65">
              When you and your loving being need or required treatment
            </p>
          </div>
          <div v-show="currentIndex === 1" class="slides">
            <img
              src="../../assets/login/Landing_page-middle_content_static_images/big-data-files.svg"
              width="100%"
              height="100%"
            />
            <h3 class="languageChange" id="langChange66">Big File Sharing</h3>
            <br />
            <p class="languageChange" id="langChange67">
              We have persistent objects, they're called files
            </p>
            <p class="Slider_content languageChange" id="langChange67">
              When Your Email Service Providers are restricting, we are
              limitless, hence you can share anything whether its movie, song,
              presentations, PDF and more without restriction
            </p>
          </div>
          <div v-show="currentIndex === 2" class="slides">
            <img
              src="../../assets/login/Landing_page-middle_content_static_images/unique_health_id.svg"
              width="100%"
              height="100%"
            />
            <h3 class="languageChange" id="langChange68">Unique Health ID</h3>
            <br />
            <p class="languageChange" id="langChange69">
              A uniform world would be any fun at all. Fortunate are the unique
            </p>
            <p class="Slider_content languageChange" id="langChange69">
              Manage Your mediacal records and documents systematically,
              professionally and efficiently under one roof with unique id.
            </p>
          </div>
          <div v-show="currentIndex === 3" class="slides">
            <img
              src="../../assets/login/Landing_page-middle_content_static_images/healthcare_institution.svg"
              width="100%"
              height="100%"
            />
            <h3 class="languageChange" id="langChange70">
              Healthcare Institutions
            </h3>
            <br />
            <p class="languageChange" id="langChange71">
              If you want other to be happy, practice Compassion, If you want to
              be happy , practice compassion
            </p>
            <p class="Slider_content languageChange" id="langChange72">
              Here you are having everything for your organization grom IT to
              Marketing prospective. Providing advance hospital information
              system in a dedicated Healthcare ERP manner.
            </p>
          </div>
          <div v-show="currentIndex === 4" class="slides">
            <img
              src="../../assets/login/Landing_page-middle_content_static_images/ambulance.svg"
              width="100%"
              height="100%"
            />
            <h3 class="languageChange" id="langChange73">Ambulance</h3>
            <br />
            <p class="languageChange" id="langChange74">
              Night or Day, we're here for you. Give way to Ambulance ! Save
              Lives !
            </p>
            <p class="Slider_content languageChange" id="langChange75">
              Ambulance around you for saving lives in emergency whether its a
              gynaecology,cardiology or any trauma accident. A truly healthcare
              services providers aremapped dedicatedly, we know the importance
              of Life.
            </p>
          </div>
          <div v-show="currentIndex === 5" class="slides">
            <img
              src="../../assets/login/Landing_page-middle_content_static_images/appointment.svg"
              width="100%"
              height="100%"
            />
            <h3 class="languageChange" id="langChange76">Appointment</h3>
            <br />
            <p class="languageChange" id="langChange77">
              Event Do not just happen, but arrive by appointment. Imediate
              whenever i can.
            </p>
            <p class="Slider_content languageChange" id="langChange78">
              Get appointment with symptom tracker effortless, where we are
              trying to save your prestigious time and reducing the health care
              queue. Now you can get 2nd and 3rd opinion with reference and
              recommandation.
            </p>
          </div>
          <div v-show="currentIndex === 6" class="slides">
            <img
              src="../../assets/login/Landing_page-middle_content_static_images/medcial_knowledge.svg"
              width="100%"
              height="100%"
            />
            <h3 class="languageChange" id="langChange79">Medical Knowledge</h3>
            <br />
            <p class="languageChange" id="langChange80">
              To know is to know that you know nothing. Knowledge is power.
            </p>
            <p class="Slider_content languageChange" id="langChange80">
              Trying to fullfill the requirements of a medical student whether
              you are studying or practicing improve health Knowledge as a
              patient too.
            </p>
          </div>
          <div v-show="currentIndex === 7" class="slides">
            <img
              src="../../assets/login/Landing_page-middle_content_static_images/health_professional.svg"
              width="100%"
              height="100%"
            />
            <h3 class="languageChange" id="langChange81">
              Health Professionals
            </h3>
            <br />
            <p class="languageChange" id="langChange82">
              The health of healthcare is kindness. Keep working until one day
              you : scalped please
            </p>
            <p class="Slider_content languageChange" id="langChange83">
              Find healthcare professionals a dedicated approach to get health
              workers, how, who, where and why they are the best for you as a
              service professionals a dedicated job portal for healthcare.
            </p>
          </div>
          <div v-show="currentIndex === 8" class="slides">
            <img
              src="../../assets/login/Landing_page-middle_content_static_images/vendor-vector.svg"
              width="100%"
              height="100%"
            />
            <h3 class="languageChange" id="langChange84">Vendor Platform</h3>
            <br />
            <p class="languageChange" id="langChange85">
              If you sell what you do, you're a vendor.If you sell why you do
              it, you,re a brand.
            </p>
            <p class="Slider_content languageChange" id="langChange86">
              A dedicated vendor engagement is a unique approach to address the
              potential of doctors to vendor institutions or patients as well as
              with chemist shops / Pharmacies online.
            </p>
          </div>
          <div v-show="currentIndex === 9" class="slides">
            <img
              src="../../assets/login/Landing_page-middle_content_static_images/virtual-assistant_new.svg"
              width="100%"
              height="100%"
            />
            <h3 class="languageChange" id="langChang87">Virtual Assistant</h3>
            <br />
            <p class="languageChange" id="langChange88">
              A secret weapon for your business that helps you get ahead. A
              trusted asset who takes away your transitions
            </p>
            <p class="Slider_content languageChange" id="langChange89">
              The assistant who work for you remotely with our dedicated tools
              and technique to address the workload efficiently or operational
              goal achiever whether single or multiple entities.
            </p>
          </div>
          <!-- Add more slides as needed -->
          <div
            @click="changeSlide(0)"
            class="dot"
            :class="{ active: currentIndex === 0 }"
          ></div>
          <div
            @click="changeSlide(1)"
            class="dot"
            :class="{ active: currentIndex === 1 }"
          ></div>
          <div
            @click="changeSlide(2)"
            class="dot"
            :class="{ active: currentIndex === 2 }"
          ></div>
          <div
            @click="changeSlide(3)"
            class="dot"
            :class="{ active: currentIndex === 3 }"
          ></div>
          <div
            @click="changeSlide(4)"
            class="dot"
            :class="{ active: currentIndex === 4 }"
          ></div>
          <div
            @click="changeSlide(5)"
            class="dot"
            :class="{ active: currentIndex === 5 }"
          ></div>
          <div
            @click="changeSlide(6)"
            class="dot"
            :class="{ active: currentIndex === 6 }"
          ></div>
          <div
            @click="changeSlide(7)"
            class="dot"
            :class="{ active: currentIndex === 7 }"
          ></div>
          <div
            @click="changeSlide(8)"
            class="dot"
            :class="{ active: currentIndex === 8 }"
          ></div>
          <div
            @click="changeSlide(9)"
            class="dot"
            :class="{ active: currentIndex === 9 }"
          ></div>
          <!-- Add more dots corresponding to the number of slides -->
          <!-- dots -->
        </div>
        <div class="loginform">
          <div class="loginform_cross" id="closeButton"></div>
          <div class="login_head">
            <div class="login_head1">
              <h1 class="Login_heading languageChange" id="langChange90">
                Welcome to our family
              </h1>
            </div>
          </div>
          <form @submit.prevent="handleSubmit" id="signup-form">
            <div class="sign_in">
              <div>
                <div class="mainFormDesign">
                  <div>
                    <div v-if="showLiveLocation" class="live_location">
                      <button @click="getLocation" type="button">
                        Get My Location
                      </button>
                      <button @click="closeModel" type="button">↩</button>
                      <div v-if="location">
                        <p>Latitude: {{ location.latitude }}</p>
                        <p>Longitude: {{ location.longitude }}</p>
                        <p>Area: {{ location.area }}</p>
                      </div>
                    </div>

                    <div class="registerFirstdiv">
                      <div class="field-of-input">
                        <select
                          ref="countrySelect"
                          v-model="selectedCountry"
                          @change="onCountryChange"
                          class="textbox-input"
                        >
                          <option
                            v-for="country in countries"
                            :key="country.isoCode"
                            :value="country.isoCode"
                          >
                            {{ country.name }}
                          </option>
                        </select>
                        <label class="form_Label-css" for=""
                          >Country Name</label
                        >
                      </div>
                      <div class="field-of-input">
                        <select
                          ref="countryCodeSelect"
                          v-model="selectedCountryCode"
                          :disabled="!selectedCountry"
                          class="textbox-input"
                        >
                          <option :value="selectedCountryCode">
                            {{ selectedCountryCode }}
                          </option>
                        </select>
                        <label class="form_Label-css" for=""
                          >Country Code</label
                        >
                      </div>
                      <div class="field-of-input">
                        <select
                          v-if="selectedCountry"
                          ref="stateSelect"
                          v-model="selectedState"
                          :disabled="!selectedCountry"
                          @change="onStateChange"
                          class="textbox-input"
                        >
                          <option
                            v-for="state in states"
                            :key="state.isoCode"
                            :value="state.isoCode"
                          >
                            {{ state.name }}
                          </option>
                        </select>
                        <label class="form_Label-css" for="">State Name</label>
                      </div>
                      <div class="field-of-input">
                        <select
                          v-if="selectedState"
                          ref="citySelect"
                          v-model="selectedCity"
                          :disabled="!selectedState"
                          class="textbox-input"
                        >
                          <option
                            v-for="city in cities"
                            :key="city.name"
                            :value="city.name"
                          >
                            {{ city.name }}
                          </option>
                        </select>
                        <label class="form_Label-css" for="">City Name</label>
                      </div>
                      <div class="field-of-input">
                        <select v-model="Prefix" class="textbox-input">
                          <option>Mr.</option>
                          <option>Ms.</option>
                          <option>Miss</option>
                          <option>Mrs.</option>
                        </select>
                        <label class="form_Label-css" for="">Prefix</label>
                      </div>
                      <div class="field-of-input">
                        <input
                          v-model="username"
                          id="signup-username"
                          type="text"
                          name="Company Code"
                          placeholder=" "
                          class="textbox-input"
                        />
                        <label class="form_Label-css" for="">
                          First Name
                        </label>
                      </div>
                      <div class="field-of-input">
                        <input
                          v-model="middleName"
                          type="text"
                          name="Company Code"
                          placeholder=" "
                          class="textbox-input"
                        />
                        <label class="form_Label-css" for="">
                          Middle Name
                        </label>
                      </div>
                      <div class="field-of-input">
                        <input
                          v-model="lastName"
                          type="text"
                          name="Company Code"
                          placeholder=" "
                          class="textbox-input"
                        />
                        <label class="form_Label-css" for=""> Last Name </label>
                      </div>
                      <div class="field-of-input">
                        <select v-model="Gender" class="textbox-input">
                          <option value="male">male</option>
                          <option value="female">female</option>
                          <option value="other">other</option>
                        </select>
                        <label class="form_Label-css" for="">Gender</label>
                      </div>
                      <div class="field-of-input">
                        <input
                          v-model="dateOfBirth"
                          type="date"
                          name="Company Code"
                          placeholder=" "
                          :max="today"
                          class="textbox-input"
                        />
                        <label class="form_Label-css" for=""> DOB</label>
                      </div>
                      <div class="field-of-input">
                        <input
                          v-model="mobile_no"
                          maxlength="12"
                          id="mobile_no"
                          type="tel"
                          name="Company Code"
                          placeholder=" "
                          class="textbox-input"
                        />
                        <label class="form_Label-css" for="">Mobile no. </label>
                      </div>
                      <div class="field-of-input">
                        <input
                          v-model="alternatenumber"
                          maxlength="12"
                          type="tel"
                          name="Company Code"
                          placeholder=" "
                          class="textbox-input"
                        />
                        <label class="form_Label-css" for=""
                          >Alternate Mobile no.
                        </label>
                      </div>

                      <div class="field-of-input">
                        <input
                          v-model="email"
                          id="signup-email"
                          type="email"
                          name="Company Code"
                          placeholder=" "
                          class="textbox-input"
                        />
                        <label class="form_Label-css" for="">
                          email address</label
                        >
                      </div>
                      <div class="field-of-input">
                        <input
                          v-model="password"
                          id="signup-password"
                          :type="showPassword ? 'text' : 'password'"
                          name="password"
                          placeholder=" "
                          class="textbox-input"
                        />
                        <label class="form_Label-css" for="signup-password"
                          >Enter Password</label
                        >
                        <span class="eye-toggle" @click="togglePassword">
                          <span v-if="showPassword">
                            <i class="fa-solid fa-eye"></i>
                          </span>
                          <span v-else
                            ><i class="fa-solid fa-eye-slash"></i
                          ></span>
                        </span>
                      </div>

                      <div class="field-of-input">
                        <input
                          v-model="confirmPassword"
                          id="confirm-password"
                          :type="showConfirmPassword ? 'text' : 'password'"
                          name="confirmPassword"
                          placeholder=" "
                          class="textbox-input"
                        />
                        <label class="form_Label-css" for="confirm-password"
                          >Confirm Password</label
                        >
                        <span class="eye-toggle" @click="toggleConfirmPassword">
                          <span v-if="showConfirmPassword">
                            <i class="fa-solid fa-eye"></i>
                          </span>
                          <span v-else
                            ><i class="fa-solid fa-eye-slash"></i
                          ></span>
                        </span>
                      </div>
                    </div>
                    <h3 style="margin: 10px 5px; color: #6b0a23">
                      Your Official Details
                    </h3>
                    <div class="registerFifthdiv">
                      <div class="field-of-input">
                        <select v-model="youreducation" class="textbox-input">
                          <option value="">-- Select Education --</option>

                          <!-- General -->
                          <optgroup label="General Education">
                            <option value="highschool">
                              High School (10th)
                            </option>
                            <option value="intermediate">
                              Intermediate (12th)
                            </option>
                            <option value="diploma">Diploma</option>
                            <option value="bachelor">Bachelor's Degree</option>
                            <option value="master">Master's Degree</option>
                            <option value="phd">Doctorate (Ph.D.)</option>
                          </optgroup>

                          <!-- Medical Stream -->
                          <optgroup label="Medical">
                            <option value="mbbs">
                              MBBS (Bachelor of Medicine and Bachelor of
                              Surgery)
                            </option>
                            <option value="bds">
                              BDS (Bachelor of Dental Surgery)
                            </option>
                            <option value="bams">
                              BAMS (Bachelor of Ayurvedic Medicine and Surgery)
                            </option>
                            <option value="bhms">
                              BHMS (Bachelor of Homeopathic Medicine and
                              Surgery)
                            </option>
                            <option value="bnys">
                              BNYS (Bachelor of Naturopathy and Yogic Sciences)
                            </option>
                            <option value="bpt">
                              BPT (Bachelor of Physiotherapy)
                            </option>
                            <option value="bot">
                              BOT (Bachelor of Occupational Therapy)
                            </option>
                            <option value="bpharm">
                              B.Pharm (Bachelor of Pharmacy)
                            </option>
                            <option value="bsc-nursing">B.Sc Nursing</option>
                            <option value="bmlt">
                              BMLT (Bachelor of Medical Lab Technology)
                            </option>
                            <option value="bopt">
                              B.Optom (Bachelor of Optometry)
                            </option>
                            <option value="bvet">
                              BVSc & AH (Bachelor of Veterinary Science & Animal
                              Husbandry)
                            </option>
                            <option value="paramedical">
                              Paramedical Courses (Diploma/UG)
                            </option>
                            <option value="md">MD (Doctor of Medicine)</option>
                            <option value="ms">MS (Master of Surgery)</option>
                            <option value="mpt">
                              MPT (Master of Physiotherapy)
                            </option>
                            <option value="mch">
                              M.Ch (Magister Chirurgiae / Super Speciality
                              Surgery)
                            </option>
                            <option value="dm">
                              DM (Doctorate of Medicine – Super Speciality)
                            </option>
                            <option value="mpharm">
                              M.Pharm (Master of Pharmacy)
                            </option>
                            <option value="msc-nursing">M.Sc Nursing</option>
                            <option value="mph">
                              MPH (Master of Public Health)
                            </option>
                            <option value="mha">
                              MHA (Master of Hospital Administration)
                            </option>
                            <option value="phd-medical">
                              Ph.D. (Medical Sciences)
                            </option>
                            <option value="dnb">
                              DNB (Diplomate of National Board)
                            </option>
                          </optgroup>

                          <!-- Finance Stream -->
                          <optgroup label="Finance & Accounting">
                            <option value="bcom">
                              B.Com (Bachelor of Commerce)
                            </option>
                            <option value="bcom-hons">B.Com (Hons)</option>
                            <option value="bba-finance">BBA (Finance)</option>
                            <option value="bbm">
                              BBM (Bachelor of Business Management)
                            </option>
                            <option value="bfia">
                              BFIA (Bachelor of Financial & Investment Analysis)
                            </option>
                            <option value="baf">
                              BAF (Bachelor of Accounting & Finance)
                            </option>
                            <option value="bbs">
                              BBS (Bachelor of Business Studies)
                            </option>
                            <option value="mcom">
                              M.Com (Master of Commerce)
                            </option>
                            <option value="mba-finance">MBA (Finance)</option>
                            <option value="mba-accounting">
                              MBA (Accounting)
                            </option>
                            <option value="msc-finance">M.Sc (Finance)</option>
                            <option value="msc-accounting">
                              M.Sc (Accounting)
                            </option>
                            <option value="ca">
                              CA (Chartered Accountant)
                            </option>
                            <option value="cfa">
                              CFA (Chartered Financial Analyst)
                            </option>
                            <option value="cpa">
                              CPA (Certified Public Accountant)
                            </option>
                            <option value="cma">
                              CMA (Certified Management Accountant)
                            </option>
                            <option value="cs">CS (Company Secretary)</option>
                            <option value="icwa">
                              ICWA (Institute of Cost and Works Accountants)
                            </option>
                            <option value="frcpa">
                              FRCPA (Financial Risk and Compliance Professional
                              Accountant)
                            </option>
                            <option value="diploma-finance">
                              Diploma in Finance
                            </option>
                            <option value="diploma-accounting">
                              Diploma in Accounting
                            </option>
                            <option value="pgdfm">
                              PGDFM (Post Graduate Diploma in Financial
                              Management)
                            </option>
                            <option value="pgdm-finance">PGDM (Finance)</option>
                            <option value="investment-banking">
                              Certificate in Investment Banking
                            </option>
                            <option value="forensic-accounting">
                              Forensic Accounting Certification
                            </option>
                            <option value="taxation">
                              Diploma in Taxation
                            </option>
                            <option value="auditing">
                              Diploma in Auditing
                            </option>
                            <option value="financial-planning">
                              Financial Planning & Wealth Management
                            </option>
                            <option value="risk-management">
                              Risk Management
                            </option>
                            <option value="international-finance">
                              International Finance
                            </option>
                            <option value="banking">Banking & Insurance</option>
                            <option value="stock-market">
                              Stock Market & Equity Trading
                            </option>
                            <option value="derivatives">
                              Derivatives & Portfolio Management
                            </option>
                          </optgroup>

                          <!-- IT / Computer Science Stream -->
                          <optgroup
                            label="Computer Science & Information Technology"
                          >
                            <option value="bca">
                              BCA (Bachelor of Computer Applications)
                            </option>
                            <option value="bsc-cs">
                              B.Sc (Computer Science)
                            </option>
                            <option value="bsc-it">
                              B.Sc (Information Technology)
                            </option>
                            <option value="btech-cs">
                              B.Tech (Computer Science)
                            </option>
                            <option value="btech-it">
                              B.Tech (Information Technology)
                            </option>
                            <option value="btech-se">
                              B.Tech (Software Engineering)
                            </option>
                            <option value="be-cs">
                              B.E. (Computer Science)
                            </option>
                            <option value="bvoc-it">
                              B.Voc (IT / Software Development)
                            </option>
                            <option value="mca">
                              MCA (Master of Computer Applications)
                            </option>
                            <option value="msc-cs">
                              M.Sc (Computer Science)
                            </option>
                            <option value="msc-it">
                              M.Sc (Information Technology)
                            </option>
                            <option value="mtech-cs">
                              M.Tech (Computer Science)
                            </option>
                            <option value="mtech-it">
                              M.Tech (Information Technology)
                            </option>
                            <option value="mtech-se">
                              M.Tech (Software Engineering)
                            </option>
                            <option value="phd-cs">
                              Ph.D. (Computer Science)
                            </option>
                            <option value="phd-it">
                              Ph.D. (Information Technology)
                            </option>
                            <option value="pgdca">
                              PGDCA (Post Graduate Diploma in Computer
                              Applications)
                            </option>
                            <option value="pgdit">
                              PGDIT (Post Graduate Diploma in Information
                              Technology)
                            </option>
                            <option value="diploma-software">
                              Diploma in Software Engineering
                            </option>
                            <option value="diploma-networking">
                              Diploma in Networking & Security
                            </option>
                            <option value="diploma-web">
                              Diploma in Web Development
                            </option>
                            <option value="diploma-mobile">
                              Diploma in Mobile App Development
                            </option>
                            <option value="data-science">
                              Certification in Data Science
                            </option>
                            <option value="ai-ml">
                              Certification in Artificial Intelligence & Machine
                              Learning
                            </option>
                            <option value="cyber-security">
                              Certification in Cyber Security
                            </option>
                            <option value="cloud-computing">
                              Certification in Cloud Computing
                            </option>
                            <option value="devops">
                              Certification in DevOps
                            </option>
                            <option value="fullstack">
                              Full Stack Development Certification
                            </option>
                            <option value="blockchain">
                              Blockchain Technology Certification
                            </option>
                            <option value="bigdata">
                              Big Data Analytics Certification
                            </option>
                            <option value="iot">
                              IoT (Internet of Things) Certification
                            </option>
                            <option value="ui-ux">
                              UI/UX Design Certification
                            </option>
                            <option value="game-dev">
                              Game Development Certification
                            </option>
                            <option value="ar-vr">
                              AR/VR Development Certification
                            </option>
                          </optgroup>

                          <!-- Other -->
                          <optgroup label="Other">
                            <option value="other">Other</option>
                          </optgroup>
                        </select>
                        <label class="form_Label-css" for="">Education</label>
                      </div>
                      <div class="field-of-input">
                        <select v-model="specialization" class="textbox-input">
                          <option value="">-- Select Specialization --</option>
                          <optgroup label="Medical Specializations">
                            <option value="general-medicine">
                              General Medicine (MD)
                            </option>
                            <option value="pediatrics">Pediatrics (MD)</option>
                            <option value="dermatology">
                              Dermatology (MD)
                            </option>
                            <option value="psychiatry">Psychiatry (MD)</option>
                            <option value="radiology">Radiology (MD)</option>
                            <option value="anatomy">Anatomy (MD)</option>
                            <option value="physiology">Physiology (MD)</option>
                            <option value="biochemistry">
                              Biochemistry (MD)
                            </option>
                            <option value="microbiology">
                              Microbiology (MD)
                            </option>
                            <option value="pharmacology">
                              Pharmacology (MD)
                            </option>
                            <option value="community-medicine">
                              Community Medicine (MD)
                            </option>
                            <option value="emergency-medicine">
                              Emergency Medicine (MD)
                            </option>
                            <option value="forensic-medicine">
                              Forensic Medicine (MD)
                            </option>
                            <option value="pulmonary-medicine">
                              Pulmonary Medicine (MD)
                            </option>
                            <option value="geriatric-medicine">
                              Geriatric Medicine (MD)
                            </option>
                            <option value="immunology">
                              Immunology / Blood Transfusion (MD)
                            </option>
                            <option value="general-surgery">
                              General Surgery (MS)
                            </option>
                            <option value="orthopedics">
                              Orthopedics (MS)
                            </option>
                            <option value="ophthalmology">
                              Ophthalmology (MS)
                            </option>
                            <option value="ent">ENT (MS)</option>
                            <option value="obstetrics-gynecology">
                              Obstetrics & Gynecology (MS)
                            </option>
                            <option value="cardiology">Cardiology (DM)</option>
                            <option value="neurology">Neurology (DM)</option>
                            <option value="gastroenterology">
                              Gastroenterology (DM)
                            </option>
                            <option value="nephrology">Nephrology (DM)</option>
                            <option value="endocrinology">
                              Endocrinology (DM)
                            </option>
                            <option value="oncology">Oncology (DM)</option>
                            <option value="hematology">Hematology (DM)</option>
                            <option value="critical-care">
                              Critical Care Medicine (DM)
                            </option>
                            <option value="cardio-thoracic-surgery">
                              Cardio-Thoracic Surgery (M.Ch)
                            </option>
                            <option value="neurosurgery">
                              Neurosurgery (M.Ch)
                            </option>
                            <option value="plastic-surgery">
                              Plastic & Reconstructive Surgery (M.Ch)
                            </option>
                            <option value="urology">Urology (M.Ch)</option>
                            <option value="pediatric-surgery">
                              Pediatric Surgery (M.Ch)
                            </option>
                            <option value="interventional-cardiology">
                              Interventional Cardiology (Fellowship)
                            </option>
                            <option value="spine-surgery">
                              Spine Surgery (Fellowship)
                            </option>
                            <option value="trauma-surgery">
                              Trauma & Acute Care Surgery (Fellowship)
                            </option>
                            <option value="maternal-fetal-medicine">
                              Maternal & Fetal Medicine (Fellowship)
                            </option>
                            <option value="vitreo-retinal-surgery">
                              Vitreo-Retinal Surgery (Fellowship)
                            </option>
                            <option value="hand-microsurgery">
                              Hand & Microsurgery (Fellowship)
                            </option>
                          </optgroup>

                          <optgroup
                            label="Finance & Accounting Specializations"
                          >
                            <option value="investment-banking">
                              Investment Banking
                            </option>
                            <option value="financial-analysis">
                              Financial Analysis
                            </option>
                            <option value="corporate-finance">
                              Corporate Finance
                            </option>
                            <option value="risk-management">
                              Risk Management
                            </option>
                            <option value="portfolio-management">
                              Portfolio Management
                            </option>
                            <option value="wealth-management">
                              Wealth Management
                            </option>
                            <option value="treasury-management">
                              Treasury Management
                            </option>
                            <option value="financial-planning">
                              Financial Planning
                            </option>
                            <option value="international-finance">
                              International Finance
                            </option>
                            <option value="banking">Banking & Insurance</option>
                            <option value="derivatives">
                              Derivatives & Equity Trading
                            </option>
                            <option value="auditing">Auditing</option>
                            <option value="taxation">Taxation</option>
                            <option value="forensic-accounting">
                              Forensic Accounting
                            </option>
                            <option value="management-accounting">
                              Management Accounting
                            </option>
                            <option value="cost-accounting">
                              Cost Accounting
                            </option>
                            <option value="corporate-accounting">
                              Corporate Accounting
                            </option>
                            <option value="financial-reporting">
                              Financial Reporting
                            </option>
                            <option value="accounting-information-systems">
                              Accounting Information Systems
                            </option>
                            <option value="chartered-accountant">
                              Chartered Accountant (CA)
                            </option>
                            <option value="chartered-financial-analyst">
                              Chartered Financial Analyst (CFA)
                            </option>
                            <option value="certified-management-accountant">
                              Certified Management Accountant (CMA)
                            </option>
                            <option value="company-secretary">
                              Company Secretary (CS)
                            </option>
                            <option value="certified-public-accountant">
                              Certified Public Accountant (CPA)
                            </option>
                            <option value="financial-risk-manager">
                              Financial Risk Manager (FRM)
                            </option>
                          </optgroup>

                          <optgroup
                            label="Computer Science & IT Specializations"
                          >
                            <option value="artificial-intelligence">
                              Artificial Intelligence (AI)
                            </option>
                            <option value="machine-learning">
                              Machine Learning (ML)
                            </option>
                            <option value="data-science">Data Science</option>
                            <option value="cyber-security">
                              Cyber Security
                            </option>
                            <option value="cloud-computing">
                              Cloud Computing
                            </option>
                            <option value="big-data">Big Data Analytics</option>
                            <option value="blockchain">
                              Blockchain Technology
                            </option>
                            <option value="internet-of-things">
                              Internet of Things (IoT)
                            </option>
                            <option value="software-development">
                              Software Development
                            </option>
                            <option value="mobile-app-development">
                              Mobile App Development
                            </option>
                            <option value="web-development">
                              Web Development
                            </option>
                            <option value="full-stack-development">
                              Full Stack Development
                            </option>
                            <option value="devops">DevOps</option>
                            <option value="ui-ux-design">UI/UX Design</option>
                            <option value="game-development">
                              Game Development
                            </option>
                            <option value="ar-vr-development">
                              AR/VR Development
                            </option>
                            <option value="networking">
                              Networking & Security
                            </option>
                            <option value="database-management">
                              Database Management
                            </option>
                            <option value="software-testing">
                              Software Testing / QA
                            </option>
                            <option value="embedded-systems">
                              Embedded Systems
                            </option>
                            <option value="computer-vision">
                              Computer Vision
                            </option>
                            <option value="natural-language-processing">
                              Natural Language Processing (NLP)
                            </option>
                          </optgroup>
                          <optgroup label="Other">
                            <option value="other">Other</option>
                          </optgroup>
                        </select>
                        <label class="form_Label-css" for=""
                          >Specialization</label
                        >
                      </div>
                      <div class="field-of-input institute_Name">
                        <input
                          v-model="officialinstituename"
                          type="text"
                          name="Company Code"
                          placeholder=" "
                          class="textbox-input"
                        />
                        <label class="form_Label-css" for=""
                          >Official Institute Name</label
                        >
                      </div>
                      <div class="field-of-input">
                        <input
                          v-model="officialinstitutebuildingnumber"
                          type="text"
                          name="Company Code"
                          placeholder=" "
                          class="textbox-input"
                        />
                        <label class="form_Label-css" for="">
                          Institute Building No.
                        </label>
                      </div>
                      <div class="field-of-input">
                        <input
                          v-model="yourinstituestreetaddress"
                          type="text"
                          name="Company Code"
                          placeholder=" "
                          class="textbox-input"
                        />
                        <label class="form_Label-css" for=""
                          >Street Address
                        </label>
                      </div>
                      <div class="field-of-input">
                        <input
                          v-model="yourinstitutelandmark"
                          type="text"
                          name="Company Code"
                          placeholder=" "
                          class="textbox-input"
                        />
                        <label class="form_Label-css" for="">
                          Institute Landmark</label
                        >
                      </div>
                      <div class="field-of-input">
                        <input
                          v-model="yourinstitutezipcode"
                          type="number"
                          name="Company Code"
                          placeholder=" "
                          class="textbox-input"
                        />
                        <label class="form_Label-css" for=""
                          >Institute zipcode</label
                        >
                      </div>
                      <div class="field-of-input">
                        <input
                          v-model="yourinstitutecityname"
                          type="text"
                          name="Company Code"
                          placeholder=" "
                          pattern="[A-Za-z]+"
                          class="textbox-input"
                        />
                        <label class="form_Label-css" for="">
                          Institute City Name</label
                        >
                      </div>
                      <div class="field-of-input">
                        <input
                          v-model="yourinstitutestatename"
                          type="text"
                          name="Company Code"
                          placeholder=" "
                           pattern="[A-Za-z]+"
                          class="textbox-input"
                        />
                        <label class="form_Label-css" for=""
                          >Institute State Name</label
                        >
                      </div>
                      <div class="field-of-input" style="display:flex; justify-content: center;">
                        <button
                          @click="handleLocationClick"
                          :class="{ saved: isSaved }"
                          style="height: 100%;"
                          v-tippy="{
                            content: 'Fetch Live Location',
                            placement: 'bottom',
                          }"
                          type="button"
                        >
                          <i
                            class="fa-solid fa-location-crosshairs"
                            style="color: #ffffff; height: 18px"
                          ></i>
                        </button>
                      </div>
                      <div class="field-of-input" style="display:flex; justify-content: center; gap: 10px; border: none;">      <button
                class="sign_up_button languageChange"
                id="iy"
                type="submit"
              >
                Sign Up
              </button>
              <button
                @click.self="closeModal"
                class="Login_button languageChange"
                type="button"
                id="login_btn"
              >
                Cancel
              </button>
            </div>
                    </div>
                  </div>
                  <!-- <div class="secondDivCrd">
                    <video
                      style="
                        height: 136px !important;
                        width: 136px !important;
                        object-fit: cover;
                        display: block !important;
                        margin: auto !important;
                      "
                      v-if="isCameraOpen && !capturedImage"
                      ref="video"
                      autoplay
                      playsinline
                      muted
                      class="camera-feed"
                    ></video>
                    <img
                      style="
                        height: 136px !important;
                        width: 136px !important;
                        object-fit: cover;
                        display: block !important;
                        margin: auto !important;
                      "
                      v-if="capturedImage || previewUrl"
                      :src="capturedImage || previewUrl"
                      alt="Captured"
                    />
                    <div v-if="isCameraOpen" class="button-container">
                      <button @click="takePhoto" type="button">Capture</button>
                      <button @click="closeCamera" type="button">
                        Close Camera
                      </button>
                    </div>

            
                  </div> -->
                </div>
              </div>
        
            </div>
          </form>
        </div>
      </section>
    </div>
  </div>

  <!-- Map modal with search functionality -->
  <Teleport to="body">
    <Transition name="modal-fade">
      <div
        v-if="showModal"
        class="modal-overlay-v01"
        @click.self="closeMapModal"
      >
        <div class="modal-container">
          <!-- Glassy Header -->
          <div class="modal-header">
            <div class="header-left">
              <div class="header-icon">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
                  />
                  <circle cx="12" cy="9" r="2.5" />
                </svg>
              </div>
              <div>
                <h3 class="modal-title">Select Location</h3>
                <p class="modal-subtitle">
                  Click map or search to pin a location
                </p>
              </div>
            </div>
            <button class="close-btn" @click="closeMapModal" aria-label="Close">
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
              >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            </button>
          </div>

          <!-- Search Bar -->
          <div class="search-container">
            <div class="search-input-wrap">
              <svg
                class="search-icon"
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.2"
                stroke-linecap="round"
              >
                <circle cx="11" cy="11" r="8" />
                <line x1="21" y1="21" x2="16.65" y2="16.65" />
              </svg>
              <input
                type="text"
                v-model="searchQuery"
                @keyup.enter="searchLocation"
                placeholder="Search for a city, address, or landmark…"
                class="search-input"
              />
              <button
                v-if="searchQuery"
                @click="searchQuery = ''"
                class="clear-btn"
                aria-label="Clear"
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.5"
                  stroke-linecap="round"
                >
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
            </div>
            <button @click="searchLocation" class="search-btn">Search</button>
            <button
              @click="getCurrentLocation"
              class="locate-btn"
              title="Use my current location"
            >
              <svg
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <circle cx="12" cy="12" r="3" />
                <path d="M12 2v3M12 19v3M2 12h3M19 12h3" />
                <path d="M12 8a4 4 0 100 8 4 4 0 000-8z" stroke-opacity="0.3" />
              </svg>
              <span class="locate-label">My Location</span>
            </button>
          </div>

          <!-- Map -->
          <div class="map-wrapper">
            <div id="map"></div>
            <div class="map-badge" v-if="!selectedLocation.lat">
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
              >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              Click anywhere on the map to drop a pin
            </div>
          </div>

          <!-- Info + Address Row -->
          <div class="info-row">
            <div class="coord-group">
              <div class="coord-box">
                <span class="coord-label">Latitude</span>
                <strong class="coord-value">{{
                  selectedLocation.lat ? selectedLocation.lat.toFixed(6) : "—"
                }}</strong>
              </div>
              <div class="coord-divider"></div>
              <div class="coord-box">
                <span class="coord-label">Longitude</span>
                <strong class="coord-value">{{
                  selectedLocation.lng ? selectedLocation.lng.toFixed(6) : "—"
                }}</strong>
              </div>
            </div>
            <div class="address-box">
              <div class="address-icon">
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z" />
                  <polyline points="9 22 9 12 15 12 15 22" />
                </svg>
              </div>
              <div class="address-text">
                <span class="coord-label">Address</span>
                <p class="address-value">
                  {{ selectedLocation.address || "No location selected yet" }}
                </p>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="modal-footer">
            <div class="footer-hint" v-if="selectedLocation.lat">
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
                stroke-linecap="round"
              >
                <polyline points="20 6 9 17 4 12" />
              </svg>
              Location pinned
            </div>
            <div class="footer-hint muted" v-else>No pin placed yet</div>
            <div class="footer-actions">
              <button class="btn-cancel" @click="closeMapModal">Cancel</button>
              <button
                class="btn-save"
                @click="confirmLocation"
                :disabled="!selectedLocation.lat || !selectedLocation.lng"
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2.2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"
                  />
                  <circle cx="12" cy="9" r="2.5" />
                </svg>
                Save Location
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import axios from "axios";
import { useToast } from "vue-toastification";
import { Country, State, City } from "country-state-city";
import notificationService from "@/notification/services/notificationService";

const toast = useToast();

export default {
  name: "RegistrationModal",
  props: {
    show: Boolean,
  },
  emits: ["close"],
  data() {
    return {
      today: new Date().toISOString().split("T")[0],
      showPassword: false,
      showConfirmPassword: false,
      showModal: false,
      map: null,
      marker: null,
      searchBox: null,
      searchQuery: "",
      selectedLocation: {
        lat: null,
        lng: null,
        address: "",
      },
      currentIndex: 0,
      countries: Country.getAllCountries(),
      states: [],
      cities: [],
      selectedCountry: null,
      selectedCountryCode: "",
      selectedState: null,
      selectedCity: null,
      location: null,
      isSaved: false,
      showLiveLocation: false,
      isFileUploadActive: false,
      isCameraActive: false,
      isCameraOpen: false,
      capturedImage: null,
      previewUrl: null,
      photo: null,
      stream: null,

      // Form fields
      username: "",
      email: "",
      password: "",
      confirmPassword: "",
      mobile_no: "",
      Prefix: "",
      middleName: "",
      lastName: "",
      dateOfBirth: "",
      alternatenumber: "",
      youreducation: "",
      specialization: "",
      officialinstituename: "",
      officialinstitutebuildingnumber: "",
      yourinstituestreetaddress: "",
      yourinstitutelandmark: "",
      yourinstitutezipcode: "",
      yourinstitutecityname: "",
      yourinstitutestatename: "",
      Gender: "",
    };
  },
  watch: {
    show(val) {
      if (val) this.startSlideShow();
    },
  },
  methods: {
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmPassword() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    async handleLocationClick() {
      // Step 1: Get current location
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const lat = position.coords.latitude;
            const lng = position.coords.longitude;

            // Save initial location
            this.selectedLocation.lat = lat;
            this.selectedLocation.lng = lng;

            // Step 2: Open modal
            this.showModal = true;

            this.$nextTick(() => {
              this.loadMap(lat, lng);
            });
          },
          (error) => {
            console.error(error);
            toast.error(
              "Unable to fetch location. Please check your location settings.",
            );
          },
        );
      } else {
        toast.error("Geolocation is not supported by your browser.");
      }
    },

    closeMapModal() {
      this.showModal = false;
      this.searchQuery = "";
    },

    loadMap(lat, lng) {
      if (!window.google) {
        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${
          process.env.VUE_APP_GOOGLE_MAPS_API_KEY || "YOUR_API_KEY"
        }&libraries=places`;
        script.async = true;
        script.defer = true;
        script.onload = () => this.initMap(lat, lng);
        document.head.appendChild(script);
      } else {
        this.initMap(lat, lng);
      }
    },

    initMap(lat, lng) {
      const center = { lat, lng };

      this.map = new google.maps.Map(document.getElementById("map"), {
        center,
        zoom: 15,
        mapTypeControl: true,
        streetViewControl: true,
        fullscreenControl: true,
      });

      this.marker = new google.maps.Marker({
        position: center,
        map: this.map,
        draggable: true,
        animation: google.maps.Animation.DROP,
      });

      // Add info window
      const infoWindow = new google.maps.InfoWindow({
        content: `<div style="padding: 10px;"><strong>Selected Location</strong><br>Lat: ${lat.toFixed(
          6,
        )}<br>Lng: ${lng.toFixed(6)}</div>`,
      });
      infoWindow.open(this.map, this.marker);

      // Click on map
      this.map.addListener("click", (event) => {
        const newLat = event.latLng.lat();
        const newLng = event.latLng.lng();

        this.marker.setPosition({ lat: newLat, lng: newLng });
        this.updateLocation(newLat, newLng);

        infoWindow.setContent(
          `<div style="padding: 10px;"><strong>Selected Location</strong><br>Lat: ${newLat.toFixed(
            6,
          )}<br>Lng: ${newLng.toFixed(6)}</div>`,
        );
        infoWindow.open(this.map, this.marker);
      });

      // Drag marker
      this.marker.addListener("dragend", (event) => {
        const newLat = event.latLng.lat();
        const newLng = event.latLng.lng();
        this.updateLocation(newLat, newLng);

        infoWindow.setContent(
          `<div style="padding: 10px;"><strong>Selected Location</strong><br>Lat: ${newLat.toFixed(
            6,
          )}<br>Lng: ${newLng.toFixed(6)}</div>`,
        );
        infoWindow.open(this.map, this.marker);
      });

      // Initial address
      this.getAddress(lat, lng);

      // Initialize search box after a short delay to ensure DOM is ready
      setTimeout(() => {
        this.initSearchBox();
      }, 500);
    },

    initSearchBox() {
      this.$nextTick(() => {
        const input = document.querySelector(".search-input");

        if (!input) {
          console.warn("Search input not found");
          return;
        }

        if (!window.google || !google.maps.places) {
          console.warn("Google Places not loaded");
          return;
        }

        // ✅ Use Autocomplete instead of SearchBox
        const autocomplete = new google.maps.places.Autocomplete(input, {
          types: ["geocode"],
        });

        // Bias results to current map
        autocomplete.bindTo("bounds", this.map);

        // When user selects suggestion
        autocomplete.addListener("place_changed", () => {
          const place = autocomplete.getPlace();

          if (!place.geometry) {
            toast.error("No details available");
            return;
          }

          const newLat = place.geometry.location.lat();
          const newLng = place.geometry.location.lng();

          this.map.setCenter(place.geometry.location);
          this.map.setZoom(15);

          if (this.marker) {
            this.marker.setPosition({ lat: newLat, lng: newLng });
          } else {
            this.marker = new google.maps.Marker({
              position: { lat: newLat, lng: newLng },
              map: this.map,
              draggable: true,
            });
          }

          this.updateLocation(newLat, newLng);

          const infoWindow = new google.maps.InfoWindow({
            content: `<div style="padding: 10px;"><strong>Selected Location</strong><br>Lat: ${newLat.toFixed(
              6,
            )}<br>Lng: ${newLng.toFixed(6)}</div>`,
          });
          infoWindow.open(this.map, this.marker);

          toast.success(`Location: ${place.formatted_address}`);
        });
      });
    },

    searchLocation() {
      if (!this.searchQuery.trim()) {
        toast.warning("Please enter a location to search");
        return;
      }

      const geocoder = new google.maps.Geocoder();

      geocoder.geocode({ address: this.searchQuery }, (results, status) => {
        if (status === "OK" && results[0]) {
          const location = results[0].geometry.location;
          const newLat = location.lat();
          const newLng = location.lng();

          this.selectedLocation.lat = newLat;
          this.selectedLocation.lng = newLng;

          this.map.setCenter({ lat: newLat, lng: newLng });
          this.map.setZoom(15);

          if (this.marker) {
            this.marker.setPosition({ lat: newLat, lng: newLng });
          } else {
            this.marker = new google.maps.Marker({
              position: { lat: newLat, lng: newLng },
              map: this.map,
              draggable: true,
            });
          }

          this.getAddress(newLat, newLng);

          const infoWindow = new google.maps.InfoWindow({
            content: `<div style="padding: 10px;"><strong>Selected Location</strong><br>Lat: ${newLat.toFixed(
              6,
            )}<br>Lng: ${newLng.toFixed(6)}</div>`,
          });
          infoWindow.open(this.map, this.marker);

          toast.success(`Location found: ${results[0].formatted_address}`);
        } else {
          toast.error(
            "Location not found. Please try a different search term.",
          );
        }
      });
    },

    getCurrentLocation() {
      if (!navigator.geolocation) {
        toast.error("Geolocation is not supported by your browser");
        return;
      }

      toast.info("Getting your current location...");

      navigator.geolocation.getCurrentPosition(
        (position) => {
          const newLat = position.coords.latitude;
          const newLng = position.coords.longitude;

          this.selectedLocation.lat = newLat;
          this.selectedLocation.lng = newLng;

          this.map.setCenter({ lat: newLat, lng: newLng });
          this.map.setZoom(15);

          if (this.marker) {
            this.marker.setPosition({ lat: newLat, lng: newLng });
          } else {
            this.marker = new google.maps.Marker({
              position: { lat: newLat, lng: newLng },
              map: this.map,
              draggable: true,
            });
          }

          this.getAddress(newLat, newLng);

          const infoWindow = new google.maps.InfoWindow({
            content: `<div style="padding: 10px;"><strong>Your Location</strong><br>Lat: ${newLat.toFixed(
              6,
            )}<br>Lng: ${newLng.toFixed(6)}</div>`,
          });
          infoWindow.open(this.map, this.marker);

          toast.success("Current location found!");
        },
        (error) => {
          let errorMessage = "Unable to retrieve your location";
          switch (error.code) {
            case error.PERMISSION_DENIED:
              errorMessage = "Location access denied by user";
              break;
            case error.POSITION_UNAVAILABLE:
              errorMessage = "Location information unavailable";
              break;
            case error.TIMEOUT:
              errorMessage = "Location request timed out";
              break;
          }
          toast.error(errorMessage);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 60000,
        },
      );
    },

    updateLocation(lat, lng) {
      this.selectedLocation.lat = lat;
      this.selectedLocation.lng = lng;
      this.getAddress(lat, lng);
    },

    getAddress(lat, lng) {
      const geocoder = new google.maps.Geocoder();

      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status === "OK" && results[0]) {
          this.selectedLocation.address = results[0].formatted_address;
        } else {
          this.selectedLocation.address = `${lat.toFixed(6)}, ${lng.toFixed(
            6,
          )}`;
        }
      });
    },

    confirmLocation() {
      if (this.selectedLocation.lat && this.selectedLocation.lng) {
        console.log("Final Location:", this.selectedLocation);

        // Save to your existing structure
        this.location = {
          latitude: this.selectedLocation.lat,
          longitude: this.selectedLocation.lng,
          area: this.selectedLocation.address,
        };
        this.isSaved = true;
        console.log("this is map location", this.location);
        toast.success("Location saved successfully!");
        this.closeMapModal();
      } else {
        toast.warning("Please select a location first");
      }
    },

    closeModal() {
      this.$emit("close");
      this.currentIndex = 0;
    },

    changeSlide(index) {
      this.currentIndex = index;
      this.startSlideShow();
    },

    startSlideShow() {
      clearTimeout(this.slideTimeout);
      this.slideTimeout = setTimeout(() => {
        this.currentIndex = (this.currentIndex + 1) % 10;
        this.startSlideShow();
      }, 3000);
    },

    onCountryChange() {
      const country = this.countries.find(
        (c) => c.isoCode === this.selectedCountry,
      );
      this.selectedCountryCode = country ? `+${country.phonecode}` : "";
      this.states = State.getStatesOfCountry(this.selectedCountry);
      this.cities = [];
      this.selectedState = null;
      this.selectedCity = null;
    },

    onStateChange() {
      this.cities = City.getCitiesOfState(
        this.selectedCountry,
        this.selectedState,
      );
      this.selectedCity = null;
    },

    async getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(async (position) => {
          const { latitude, longitude } = position.coords;
          const response = await axios.get(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`,
          );
          this.location = {
            latitude,
            longitude,
            area: response.data.display_name,
          };
          this.isSaved = true;
          toast.success("Location fetched successfully!");
        });
      } else {
        toast.error("Geolocation is not supported.");
      }
    },

    handleFileUpload(event) {
      this.isFileUploadActive = true;
      this.isCameraActive = false;
      const file = event.target.files[0];
      if (file && file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onload = (e) => (this.previewUrl = e.target.result);
        reader.readAsDataURL(file);
        this.photo = file;
      }
    },

    async takePhoto() {
      if (this.stream) {
        const video = this.$refs.video;
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas.getContext("2d").drawImage(video, 0, 0);
        const dataUrl = canvas.toDataURL("image/jpeg");
        this.capturedImage = dataUrl;
        this.photo = await fetch(dataUrl).then((res) => res.blob());
        this.closeCamera();
      }
    },

    closeCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach((track) => track.stop());
        this.stream = null;
      }
      this.isCameraOpen = false;
      this.isCameraActive = false;
    },

    openCamera() {
      this.isCameraActive = true;
      this.isFileUploadActive = false;
      this.capturedImage = null;
      this.isCameraOpen = true;
      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then((stream) => {
          this.stream = stream;
          if (this.$refs.video) {
            this.$refs.video.srcObject = stream;
          }
        })
        .catch((err) => toast.error("Camera access denied."));
    },

    validateForm() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      const phoneRegex = /^\d{10}$/;

      if (!this.email || !emailRegex.test(this.email))
        return toast.error("Valid email required."), false;
      if (!this.password || this.password.length < 8)
        return toast.error("Password must be 8+ chars."), false;
      if (this.password !== this.confirmPassword)
        return toast.error("Passwords don't match."), false;
      if (!this.username || this.username.length < 3)
        return toast.error("Username too short."), false;
      if (!phoneRegex.test(this.mobile_no))
        return toast.error("Valid 10-digit mobile required."), false;
      if (!this.selectedCountry || !this.selectedState || !this.selectedCity)
        return toast.error("Select location."), false;
      if (!this.dateOfBirth) return toast.error("Select DOB."), false;
      if (!this.Gender) return toast.error("Select gender."), false;
      if (!this.location) return toast.error("Fetch location first."), false;

      return true;
    },

    async handleSubmit() {
      if (!this.validateForm()) return;

      const { deviceInfo, deviceLocation } =
        await notificationService.getDeviceInfoAndLocation();
      const formData = new FormData();

      const fields = {
        username: this.username,
        firstName: this.username,
        email: this.email,
        password: this.password,
        mobile_no: this.mobile_no,
        Prefix: this.Prefix,
        middleName: this.middleName,
        lastName: this.lastName,
        selectedCountry: this.selectedCountry,
        selectedState: this.selectedState,
        selectedCity: this.selectedCity,
        dateOfBirth: this.dateOfBirth,
        alternatenumber: this.alternatenumber,
        youreducation: this.youreducation,
        specialization: this.specialization,
        officialinstituename: this.officialinstituename,
        officialinstitutebuildingnumber: this.officialinstitutebuildingnumber,
        yourinstituestreetaddress: this.yourinstituestreetaddress,
        yourinstitutelandmark: this.yourinstitutelandmark,
        yourinstitutezipcode: this.yourinstitutezipcode,
        yourinstitutecityname: this.yourinstitutecityname,
        yourinstitutestatename: this.yourinstitutestatename,
        Gender: this.Gender,
        location: JSON.stringify(this.location),
        deviceInfo: JSON.stringify(deviceInfo),
        deviceLocation: JSON.stringify(deviceLocation),
      };
      console.log("This is form data", fields);
      Object.entries(fields).forEach(([key, value]) =>
        formData.append(key, value),
      );
      if (this.photo) formData.append("photo", this.photo);

      try {
        const response = await axios.post(
          `${process.env.VUE_APP_BASE_URL}auth/signup`,
          formData,
          { headers: { "Content-Type": "multipart/form-data" } },
        );

        if (response.status === 200) {
          toast.success("Registration successful! Check email to verify.");
          this.$router.push("/registration-successful");
          this.closeModal();
        }
      } catch (err) {
        toast.error(
          err.response?.data?.message || "Email or mobile already exists.",
        );
      }
    },

    redirectToFacebookLogin() {
      window.location.href = `${process.env.VUE_APP_BASE_URL}auth/facebook`;
    },

    closeModel() {
      this.showLiveLocation = false;
    },
  },
  mounted() {
    if (this.show) this.startSlideShow();
  },
  beforeUnmount() {
    clearTimeout(this.slideTimeout);
    if (this.stream) this.stream.getTracks().forEach((t) => t.stop());
  },
};
</script>

<style scoped>
@import url(./landing_page_middle_search.css);

/* Modal Styles */
.field-of-input {
  position: relative; /* required for eye icon positioning */
}

.eye-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  color: #6b0a23;
  font-size: 16px;
  user-select: none;
  transition: opacity 0.2s ease;
}

.eye-toggle:hover {
  opacity: 0.75;
}
.registration-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 1rem;
  overflow-y: auto;
}

.registration-modal-content {
  position: relative;
  background: #fff;
  border-radius: 16px;
  max-width: 960px;
  width: 100%;
  max-height: 95vh;
  overflow-y: auto;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.15);
}

.modal-close-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: #666;
  z-index: 10;
}

.modal-close-btn:hover {
  color: #333;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .registration-modal-content {
    margin: 1rem;
    max-height: 90vh;
  }
}

/* Map modal start here styles */
/* ── Map Modal Overlay ── */
.modal-overlay-v01 {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  z-index: 9999;
}

/* ── Modal Container ── */
.modal-container {
  background: #fff;
  border-radius: 6px;
  width: 100%;
  max-width: 680px;
  max-height: 92vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  scrollbar-width: none;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
}

/* ── Header ── */
.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 20px 14px;
  border-bottom: 0.5px solid #e5e7eb;
  position: sticky;
  top: 0;
  background: #fff;
  z-index: 10;
  border-radius: 16px 16px 0 0;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: #eef2ff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b0a23;
  flex-shrink: 0;
}

.modal-title {
  font-size: 15px;
  font-weight: 500;
  color: #111827;
  line-height: 1.3;
}

.modal-subtitle {
  font-size: 12px;
  color: #6b7280;
  margin-top: 1px;
}

.close-btn {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 0.5px solid #e5e7eb;
  background: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  flex-shrink: 0;
  transition: background 0.15s;
}

.close-btn:hover {
  background: #f3f4f6;
}

/* ── Search Bar ── */
.search-container {
  display: flex;
  gap: 8px;
  align-items: center;
  padding: 14px 20px;
  border-bottom: 0.5px solid #e5e7eb;
  flex-wrap: wrap;
}

.search-input-wrap {
  flex: 1;
  min-width: 180px;
  position: relative;
  display: flex;
  align-items: center;
}

.search-icon {
  position: absolute;
  left: 10px;
  color: #9ca3af;
  pointer-events: none;
}

.search-input {
  width: 100%;
  height: 36px;
  padding: 0 32px 0 32px;
  border: 0.5px solid #d1d5db;
  border-radius: 8px;
  font-size: 13px;
  color: #111827;
  background: #f9fafb;
  outline: none;
  transition: border 0.15s, background 0.15s;
}

.search-input:focus {
  border-color: #6b0a23;
  background: #fff;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.search-input::placeholder {
  color: #9ca3af;
}

.clear-btn {
  position: absolute;
  right: 8px;
  background: none;
  border: none;
  cursor: pointer;
  color: #9ca3af;
  padding: 2px;
  display: flex;
  align-items: center;
}

.clear-btn:hover {
  color: #6b7280;
}

.search-btn {
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  background: #a2082f;
  color: #fff;
  border: none;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
}

.search-btn:hover {
  background: #6b0a23;
}

.locate-btn {
  height: 36px;
  padding: 0 12px;
  border-radius: 8px;
  border: 0.5px solid #d1d5db;
  background: #fff;
  color: #374151;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
  transition: background 0.15s, border-color 0.15s;
  white-space: nowrap;
}

.locate-btn:hover {
  background: #f3f4f6;
  border-color: #6b0a23;
}

/* ── Map ── */
.map-wrapper {
  position: relative;
  height: 300px;
  min-height: 220px;
  background: #e5e7eb;
}

#map {
  width: 100%;
  height: 100%;
}

.map-badge {
  position: absolute;
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(255, 255, 255, 0.95);
  border: 0.5px solid #e5e7eb;
  border-radius: 20px;
  padding: 5px 12px;
  font-size: 11.5px;
  color: #6b7280;
  display: flex;
  align-items: center;
  gap: 5px;
  white-space: nowrap;
  pointer-events: none;
}

/* ── Info Row (coords + address) ── */
.info-row {
  display: flex;
  border-top: 0.5px solid #e5e7eb;
  flex-wrap: wrap;
}

.coord-group {
  display: flex;
  align-items: stretch;
  border-right: 0.5px solid #e5e7eb;
  flex-shrink: 0;
}

.coord-box {
  padding: 12px 16px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 110px;
}

.coord-divider {
  width: 0.5px;
  background: #e5e7eb;
}

.coord-label {
  font-size: 11px;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.coord-value {
  font-size: 13px;
  font-weight: 500;
  color: #111827;
  font-variant-numeric: tabular-nums;
}

.address-box {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 16px;
  flex: 1;
  min-width: 180px;
}

.address-icon {
  width: 26px;
  height: 26px;
  background: #f3f4f6;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  flex-shrink: 0;
  margin-top: 2px;
}

.address-text {
  flex: 1;
}

.address-value {
  font-size: 12.5px;
  color: #374151;
  margin-top: 3px;
  line-height: 1.5;
}

/* ── Footer ── */
.modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  border-top: 0.5px solid #e5e7eb;
  background: #f9fafb;
  border-radius: 0 0 16px 16px;
  flex-wrap: wrap;
  gap: 10px;
  position: sticky;
  bottom: 0;
}

.footer-hint {
  font-size: 12px;
  color: #10b981;
  display: flex;
  align-items: center;
  gap: 5px;
}

.footer-hint.muted {
  color: #9ca3af;
}

.footer-actions {
  display: flex;
  gap: 8px;
}

.btn-cancel {
  height: 34px;
  padding: 0 16px;
  border-radius: 8px;
  border: 0.5px solid #d1d5db;
  background: #fff;
  font-size: 13px;
  color: #374151;
  cursor: pointer;
  transition: background 0.15s;
}

.btn-cancel:hover {
  background: #f3f4f6;
}

.btn-save {
  height: 34px;
  padding: 0 16px;
  border-radius: 8px;
  background: #6b0a23;
  color: #fff;
  border: none;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: background 0.15s;
}

.btn-save:hover {
  background: #6b0a23;
}

.btn-save:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* ── Vue Transition ── */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
  transform: scale(0.97);
}

/* ── Responsive ── */
@media (max-width: 520px) {
  .modal-container {
    border-radius: 12px;
    max-height: 96vh;
    scrollbar-width: none;
  }

  .modal-header {
    padding: 14px 16px 12px;
  }

  .search-container {
    padding: 10px 14px;
  }

  .search-btn {
    padding: 0 12px;
  }

  /* Hide label, keep icon on small screens */
  .locate-label {
    display: none;
  }

  .locate-btn {
    padding: 0 10px;
  }

  .map-wrapper {
    height: 220px;
  }

  /* Stack coord group above address on mobile */
  .coord-group {
    border-right: none;
    border-bottom: 0.5px solid #e5e7eb;
    flex-basis: 100%;
  }

  .address-box {
    flex-basis: 100%;
  }

  .modal-footer {
    padding: 10px 14px;
  }

  .coord-box {
    min-width: 90px;
  }
}
/* Map modal end here styles */
</style>
